var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-header',{attrs:{"showStyle":"white"}}),_c('div',{staticClass:"bg-box"},[_c('div',{staticClass:"wrap f-row-c-s"},[_c('v-sidebar'),_c('div',{staticClass:"w100"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }